import React from "react";

type MockedCardType = {
    gradient: string;
    colors: string[];
    currentColorIndex?: number | null;
    positions: number[]
    onIndexChange: (e: number) => void
}
export const MockedProductCard: React.FC<MockedCardType>
    = ({
        gradient,
        colors,
        positions,
        currentColorIndex,
        onIndexChange
    }) => (
        <div className="flex flex-col justify-center items-center w-full">
            <div
                className="card card-compact w-full max-w-[250px] mb-3 mt-10 
                bg-secondary shadow-md rounded-lg overflow-hidden relative">

                <figure className="relative">
                    <img
                        src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.pngmart.com%2Ffiles%2F16%2FPlastic-Water-Bottle-PNG-HD.png&f=1&nofb=1&ipt=73c431f46828ba1c9d7e2bf64f50fabe3e519b17ce7a43e639a18068f76b5b3f"
                        alt='mock-product-name'
                        style={{
                            background: gradient,
                        }}
                        className="w-full  resize-contain h-[190px] md:h-40 lg:h-38 object-contain cursor-pointer"
                    />
                    {colors.map((color, index) => (
                        <div
                            key={index}
                            className={`w-3 h-3 rounded-full border-2 border-white 
                            absolute -translate-x-1/2 top-1/2 -translate-y-1/2 
                            cursor-grab hover:scale-110 transition-transform ${currentColorIndex === index
                                    ? 'ring-2 ring-blue-500 ring-offset-2 scale-115 z-20'
                                    : ''
                                }`}
                            style={{
                                left: `${positions[index]}%`,
                                backgroundColor: color,
                                zIndex: 20,
                            }}
                            onClick={(e) => {
                                e.preventDefault();
                                onIndexChange(index);
                            }}
                        />
                    ))}
                </figure>
                <div className="p-2">
                    <h2 className="card-title text-[0.75rem] sm:text-xs lg:text-sm text-white font-medium leading-tight">
                        Nom du produit
                    </h2>
                    <p className="text-[0.75rem] sm:text-xs lg:text-sm text-white font-semibold text-right leading-tight">
                        10 000 Fcfa
                    </p>
                </div>
            </div>
        </div>
    )